import HTTPClient from 'lib/helpers/HTTPClient'
import { httpErrorParser } from 'lib/helpers/utilities'

import ReduxState from 'models/redux'
import { Notification, NotificationType } from 'models/general'
import { ReduxAction } from 'models/thunk'

/** Action type to set the user's pending invitations */
export const SET_INVITATIONS = '@User/SET_INVITATIONS'

const api = process.env.REACT_APP_APIURL || '/api'

export const setInvitations = (
  value: Notification[]
): ReduxAction<Notification[]> => ({
  type: SET_INVITATIONS,
  value,
})

/**
 * Gets unreaded notifications
 */
export const getInvitations =
  () => async (dispatch: any, getStore: () => ReduxState) => {
    const client = HTTPClient.getClient()
    try {
      const petition = await client.get(`${api}/invitations`)
      const data = await petition.json()
      const invitations: Notification[] = data.map((i: any) => ({
        id: i.idInvitation,
        type: NotificationType.INVITATION,
        message: i.workspaces.name,
        relatedId: i.workspaces.idWorkspace,
        read: false,
      }))

      dispatch(setInvitations(invitations))
    } catch (err: any) {
      const error = await httpErrorParser(err)
      throw error
    }
  }
